import { render, staticRenderFns } from "./FinalizeContent.vue?vue&type=template&id=002cbae4&"
import script from "./FinalizeContent.vue?vue&type=script&lang=js&"
export * from "./FinalizeContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports